import React, { useEffect, useState } from "react";
import { useGetCookie } from "../../../hooks/useGetCookie";
import { useToolbarCookieResultNotification } from "../../../hooks/useToolbarCookieResultNotification";
import { ExtensionModal } from "../../../components/presession/ExtensionModal";
import { useNavigateStore } from "../../../stepFlowHooks/useNavigateStore";
import { useSessionDataStore } from "../../../hooks/useSessionDataStore";
import { shouldHideExtensionModal } from "../../../utils/cookieSyncUtils";

// TODO [LOWA-30534] from https://tiny.amazon.com/60koy8d5
export const CookieSyncSetup = () => {
    const navigateToSignInStep = useNavigateStore(
        (store) => store.navigateToSignInStep
    );
    const { cookieResult } = useGetCookie();
    const [showExtensionModal, setShowExtensionModal] = useState(false);
    const setCookieSyncTarget = useSessionDataStore(
        (store) => store.setCookieSyncTarget
    );

    useToolbarCookieResultNotification(cookieResult);

    useEffect(() => {
        if (cookieResult == null) {
            return;
        }
        setCookieSyncTarget(cookieResult.cookies);

        setShowExtensionModal(
            cookieResult.error === "EXTENSION_NOT_INSTALLED" &&
                !shouldHideExtensionModal()
        );
    }, [cookieResult]);

    if (showExtensionModal) {
        return (
            <ExtensionModal
                dismissExtensionModal={() => {
                    setShowExtensionModal(false);
                }}
                onRedirectToLogin={navigateToSignInStep}
            />
        );
    }

    return <></>;
};
